
  import { defineComponent } from 'vue'
  import { mapGetters } from 'vuex';
  import { ToastFactory } from '@/utils/ToastFactory';
  import OrganizationInterface from '@/interfaces/Organization.interface';
  import { OrganizationService } from '../Organizations/organization.service';
  import { GroupService } from './group.service';
  import { GroupInterface } from '@/interfaces/Group.interface';
  const organizationService = new OrganizationService();
  const groupService = new GroupService();
  
  
  export default defineComponent({
    name: 'addGroupOrganization',
    data() {
      return {
        groupId: "" as string,
        group:{
          organizationAccess: [] as any,
      } as GroupInterface,
        organizations: [] as any,
        organization: {} as OrganizationInterface,
        pickedOrganization: {
          id: "",
          name: "",
          cnpj: "",
          status: false
        } as any,
        groupAdded: {} as any,
        params: { name: "", page: 0, size: 100}
      }
    },
  
    computed: {
      ...mapGetters({
        storeGroup: "groups/getGroup",
        storeOrganizations: "orgs/getOrganizations",
        storeOrg: "orgs/getOrganization",
      }),
    },
  
    methods:{
      async getGroupById(){
        groupService.getGroupById(this.groupId).then(() => {
          this.group = this.storeGroup;
        });
      },

      async getOrganizations(event: any){
        this.params.name = event.query;
        await organizationService.getOrganizations(this.params).then(() => {
          this.organizations = this.storeOrganizations.content;
        })
      },

      getOrganizationID(){
        organizationService.getOrganizationById(this.pickedOrganization).then(() => {
          this.pickedOrganization = this.storeOrg;
        });
      },

      async addNewOrganization(){
        this.organization = this.organizations.find((organization: OrganizationInterface) => organization.id === this.pickedOrganization.id);
        this.addOrgToGroup(this.organization.id);
      },

      confirmeRemove(id: any){
        this.$confirm.require({
          header: this.$t('group.deleteAcess'),
                message: this.$t('group.confirmDeleteAcess'),
                accept: () => {
                    this.removeOrgGroup(id);
                },
                reject: () => {
                    console.log('reject');
                }
        })
      },

      async getOrganizationById(){
            organizationService.getOrganizationById(this.pickedOrganization).then(() => {
                this.organization = this.storeOrg;
            });
        },

      async addOrgToGroup(organizationId: string): Promise<void>{
        this.groupAdded = {
          organizationId: organizationId,
          id: this.groupId
        }
        await groupService.addOrganizationToGroup(this.groupId, organizationId)
        .then(() => {
          this.$toast.add(ToastFactory.success(this.$t("toast.sucessAddOrg")));
          this.getGroupById();
        }).catch((e) => {
          console.log(e)
          this.$toast.add(ToastFactory.error(this.$t("toast.errorAddOrg")));
        });
      },

      async removeOrgGroup(idOrg: any){
        let data = {
          id: this.groupId,
          organizationId: idOrg
        }
       
        await groupService.removeOrganizationFromGroup(data)
        .then(() => {
          this.$toast.add(ToastFactory.success(this.$t("toast.sucessOrgDelete")));
        }).catch((e) => {
          console.log(e)
          this.$toast.add(ToastFactory.error(this.$t("toast.errorOrgDelete")));
        });
      },

      sendGroup(){
        this.$router.push({ name: 'Groups'});
      }
    },
  
    mounted(){
      this.groupId = this.$route?.params?.id as string;
      this.groupId ? this.getGroupById() : null;
    }
  })
  